import { connect } from 'redux-bundler-react';
import Card from '@src/app-components/card';
import DataHeader from '../components/data-header/dataHeader';
import TabContainer from '@src/app-components/tab';
import TelemetryDataEntry from '../tables/telemetry/TelemetryDataEntry';
import Breadcrumb from '@src/app-components/breadcrumb';

import SearchEffortDataEntryForm from '../../edit-data-sheet/forms/search-effort/SearchEffortDataEntryForm';
import Approval from '../components/approval/approval';

import '../../../data-summaries/data-summary.scss';
import NavigateWarningModal from '@src/common/modals/NavigateWarningModal';
import { useState } from 'react';

const SearchEffortOverview = connect(
  'doModalOpen',
  'doUpdateCurrentTab',
  'selectDataEntryData',
  'selectDataEntryTelemetryTotalCount',
  'selectCurrentTab',
  'selectRouteParams',
  'selectIsEditForm',
  ({
    doModalOpen,
    doUpdateCurrentTab,
    dataEntryData,
    dataEntryTelemetryTotalCount,
    currentTab,
    routeParams,
    isEditForm,
  }) => {
    const siteId = routeParams?.siteId;
    const seId = routeParams?.seId;

    // Navigation Warning Modal Dirty State
    const [isSearchDirty, setIsSearchDirty] = useState(false);
    const [isTelemetryDirty, setIsTelemetryDirty] = useState(false);

    const isOnline = navigator.onLine;
    const searchDraftKey = `currentSearchEffortDraft:${siteId}`;
    const savedSearchDraft = sessionStorage.getItem(searchDraftKey);
    let searchDraft = null;
    try {
      searchDraft = savedSearchDraft ? JSON.parse(savedSearchDraft) : null;
    } catch (err) {
      console.error('Failed to parse Search Effort draft:', err);
    }
    const searchSaved =
      Boolean(seId) || Boolean(savedSearchDraft) || Boolean(dataEntryData?.seId) || Boolean(dataEntryData?.seFid);
    const recoveryOutboxId = sessionStorage.getItem('syncRecoveryOutboxId');
    const recoveryTelemetryCount = Number(searchDraft?.telemetryCount || 0);
    const displayTelemetryCount = recoveryOutboxId
      ? Math.max(Number(dataEntryTelemetryTotalCount || 0), recoveryTelemetryCount)
      : Number(dataEntryTelemetryTotalCount || 0);

    const breadcrumbLinks = [
      { text: 'Sites List', href: '/sites-list', current: false },
      { text: siteId, href: `/sites-list/${siteId}`, current: false },
      { text: `Search Effort - ${seId ? seId : 'Create'}`, current: true },
    ];

    return (
      <div className='container-fluid search-overview-container'>
        <Breadcrumb paths={breadcrumbLinks} />

        <div className='row'>
          <div className='col-9'>
            <h4>{isEditForm ? '' : 'Create'} Search Effort Datasheet</h4>
          </div>
        </div>

        {/* Top Level Info */}
        <DataHeader type='search-effort' />

        {/* Approval Fields */}
        {isOnline && <Approval />}

        {/* Form */}
        <Card className='mt-3'>
          <Card.Header text='Search Effort and Related Data' />
          <Card.Body>
            <p>
              Select any tab to view Search Effort and Telemetry datasheet data for Search Effort ID:{' '}
              {dataEntryData?.seId}
            </p>

            <TabContainer
              tabs={[
                {
                  title: 'Search Effort',
                  content: <SearchEffortDataEntryForm onDirtyChange={setIsSearchDirty} />,
                },
                ...(searchSaved
                  ? [
                      {
                        title: `Telemetry (${displayTelemetryCount})`,
                        content: <TelemetryDataEntry onDirtyChange={setIsTelemetryDirty} />,
                      },
                    ]
                  : []),
              ]}
              onTabChange={(_str, ind) => {
                if (ind === 1 && !searchSaved) return;
                if (currentTab === 0 && ind !== 0 && isSearchDirty) {
                  doModalOpen(NavigateWarningModal, {
                    onNavigate: () => {
                      setIsSearchDirty(false);
                      doUpdateCurrentTab(ind);
                    },
                  });
                  return false;
                }
                if (currentTab === 1 && ind !== 1 && isTelemetryDirty) {
                  doModalOpen(NavigateWarningModal, {
                    onNavigate: () => {
                      setIsTelemetryDirty(false);
                      doUpdateCurrentTab(ind);
                    },
                  });
                  return false;
                }
                doUpdateCurrentTab(ind);
              }}
              defaultTab={searchSaved ? currentTab : 0}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
);

export default SearchEffortOverview;
